module.exports = __webpack_public_path__ + "img/bsc.1c64ad8e.svg";